<template>
  <Line
    class="line-chart"
    data-qa-id="line-chart"
    :data="chartData"
    :options="chartOptions"
  />
</template>
<script src="./script.js"></script>

<style>
canvas{
  height: 100%;
  width: 100%;
}
.line-chart{
  height: 500px;
}
</style>
